import { doc, getDoc } from "firebase/firestore";
import { db } from "@/config/firebase";
const LOCAL_VERSAO_KEY = "versao_frontend";

const isLocalHost = () => {
  const host = (window.location.hostname || '').toLowerCase();
  return host === 'localhost' || host === '127.0.0.1';
};

export async function checarVersaoFrontend() {
  try {
    // Em ambiente local evitamos reload automático para não gerar loop de desenvolvimento.
    if (isLocalHost()) return;

    const docRef = doc(db, "configuracoes", "versao");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const versaoFirebase = (docSnap.data().versaoAtualFrontend || '').toString().trim();
      if (!versaoFirebase) return;
      const versaoLocal = (localStorage.getItem(LOCAL_VERSAO_KEY) || '').toString().trim();
      if (versaoLocal !== versaoFirebase) {
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem(LOCAL_VERSAO_KEY, versaoFirebase);
        window.location.reload();
      }
    } else {
      console.warn("Documento de versão não encontrado.");
    }
  } catch (error) {
    console.error("Erro ao verificar versão:", error);
  }
}
